import { createSelector } from 'reselect';
import { showSelector } from 'selectors/testTarget/offers/discountedPriceWithCode/show/showSelector';
import { isTestTargetReadySelector } from 'viewModel/selectors/testTarget/isTestTargetReadySelector';

const showDiscountedPriceWithCodeSelector = createSelector(isTestTargetReadySelector, showSelector, (testReady, show) => testReady && show);

export { showDiscountedPriceWithCodeSelector };
